const messages = {
  en: {
    translations: {
      appointments: {
        menu: {
          calendar: 'Calendar',
        },
        tooltip: {
          details: 'Details',
          busyHint: 'Time taken by a Google Calendar event. The event details are not shown.',
        },
        grid: {
          title: 'Select a time',
          chooseType: 'Choose the appointment type to see the free times.',
          previousMonth: 'Previous month',
          nextMonth: 'Next month',
          previousWeek: 'Previous week',
          nextWeek: 'Next week',
          freeDaysHint: 'Highlighted days have free times.',
          noWeekSlots: 'No free times this week. Use the arrows or pick another day in the month.',
          changeTime: 'Change time',
          sideBySide: 'Side by side',
        },
        phase6: {
          myAgenda: 'My calendar: {{name}}',
          connectedAs: 'Google connected: {{email}}',
          clinicFallback: 'No Google account of their own; the clinic calendar applies.',
          connectOwnGoogle: 'Connect my Google',
          reconnectOwnGoogle: 'Reconnect my Google',
          disconnectOwnGoogle: 'Disconnect own Google account',
          connectOwnGoogleHint: 'Professionals connect their own Google on their Agenda screen.',
          myGoogleCalendar: 'My Google calendar',
          disconnectTitle: 'Disconnect Google',
          disconnectMessage: 'The events already created in Google stay there. Disconnect this account?',
          accessUser: 'Access user',
          noAccessUser: 'No access of their own',
          ownHours: 'Own working hours',
          hoursHint: 'Without own hours, the clinic hours apply. With own hours, days without a period are closed. For each day, enter the start and end of the first period and, if needed, of the second.',
          firstPeriod: 'First period',
          secondPeriod: 'Second period',
          start: 'start',
          end: 'end',
          noClinicCalendar: 'No clinic calendar',
          changeProfessional: 'Change professional',
          saveChange: 'Save change',
          professionalChanged: 'Professional changed.',
          professionalChangedTo: 'Professional changed to {{name}}',
        },
        reports: {
          title: 'Agenda reports',
          subtitle: 'Track confirmations, no-shows, cancellations and AI usage in the selected period.',
          lastDays: 'Last {{days}} days',
          from: 'From',
          to: 'To',
          invalidPeriod: 'Choose a period of 1 to 366 days.',
          note: 'Counts the appointments that start in the period.',
          total: 'Appointments',
          confirmationRate: 'Confirmation rate',
          confirmedCount: '{{count}} confirmed',
          noShowRate: 'No-show rate',
          noShowHint: 'Among those with an outcome',
          cancellations: 'Cancellations',
          reschedules: 'Reschedules',
          byAi: '{{count}} by AI',
          byStatus: 'By status',
          cancellationsByOrigin: 'Cancellations by origin',
          reschedulesByOrigin: 'Reschedules by origin',
          byProfessional: 'By professional',
          byType: 'By appointment type',
          clinicCalendar: 'Clinic calendar',
          noType: 'No type',
          aiUsage: 'AI usage in the period',
          repliesRead: 'Replies read',
          modelCalls: 'Model calls',
          tokens: 'Tokens',
          failures: 'Failures',
          empty: 'No records in the period.',
          name: 'Name',
          attended: 'Attended',
          noShows: 'No-shows',
          cancelled: 'Cancelled',
          origins: {
            user: 'Attendant',
            whatsapp: 'Customer (WhatsApp)',
            ai: 'AI',
            google: 'Google Calendar',
            system: 'System',
          },
        },
        notifications: {
          tab: 'Notifications',
          intro: 'The system notifies the customer by WhatsApp, understands the reply (confirm, cancel or reschedule) and updates the appointment.',
          connection: 'WhatsApp connection for notifications',
          off: 'Off',
          handoffQueue: 'Queue for conversations handed to a person',
          noQueue: 'None (keeps the current queue)',
          reminders: 'Automatic reminders',
          daysBefore: '{{amount}} day(s) before',
          hoursBefore: '{{amount}} hour(s) before',
          minutesBefore: '{{amount}} minutes before',
          messages: 'Messages',
          variables: 'Variables',
          variablesHint: 'Click a variable to copy it and paste it into the message text. When sending, it is replaced by the appointment data.',
          variableCopied: '{{variable}} copied.',
          copyFailed: 'Could not copy. Select and copy the variable manually.',
          copyVariable: 'Copy {{variable}}',
          variableDescriptions: {
            nome: 'Contact name',
            data: 'Appointment date',
            hora: 'Appointment time',
            tipo: 'Appointment type',
            empresa: 'Company name',
            opcoes: 'Numbered list: times when rescheduling or appointments to choose from',
          },
          restoreDefault: 'Restore default',
          sending: 'Sending',
          preview: 'WhatsApp preview',
          customized: 'Customized',
          groups: {
            request: 'Reply requests',
            replies: 'Replies to the customer',
            reschedule: 'AI rescheduling',
          },
          notifyOnCreate: 'Send confirmation by WhatsApp',
          notifyCustomer: 'Notify the customer by WhatsApp',
          sent: 'Sent by WhatsApp: {{notification}}',
          sendFailed: 'Could not send by WhatsApp: {{notification}}',
          notes: {
            max_rounds: 'Handed to an attendant: no time was accepted',
            no_slots: 'Handed to an attendant: no free times',
            handoff: 'Handed to an attendant',
            taken_over: 'Conversation taken over by an attendant',
          },
          conversation: 'WhatsApp conversation',
          resend: 'Resend notification',
          resent: 'Notification sent.',
          takeOver: 'Take over conversation',
          tookOver: 'Conversation taken over.',
          kinds: {
            reschedulePreference: 'Reschedule: preferred day question',
            rescheduleOptions: 'Reschedule: offered times',
            rescheduleDone: 'Reschedule: time rescheduled',
            noSlots: 'Reschedule: no free times',
            whichAppointment: 'Which appointment question',
            confirmationRequest: 'Confirmation request',
            reminder: 'Reminder',
            rescheduled: 'New time notice',
            confirmed: 'Confirmation',
            cancelled: 'Cancellation notice',
            cancelQuestion: 'Cancellation question',
            cancelKept: 'Time kept notice',
            unclear: 'Request to repeat the reply',
            handoff: 'Human attendant notice',
          },
          stages: {
            reschedule_collect: 'Rescheduling with AI: waiting for the preferred day',
            reschedule_choose: 'Rescheduling with AI: waiting for the time choice',
            awaiting_reply: 'Waiting for the customer\'s reply',
            awaiting_cancel_confirmation: 'Waiting for the cancellation confirmation',
            handed_off: 'With an attendant',
            done: 'Conversation completed',
            expired: 'Conversation ended without a reply',
          },
          intents: {
            confirm: 'Confirm',
            cancel: 'Cancel',
            reschedule: 'Reschedule',
            question: 'Question',
            handoff: 'Talk to an attendant',
            unclear: 'Not understood',
          },
          noReplies: 'The customer has not replied yet.',
          readings: {
            number: 'Answered with the option number',
            keyword: 'Identified by keyword',
            ai: 'Interpreted by AI',
            fallback: 'Could not be understood',
          },
          sources: {
            number: 'Number',
            keyword: 'Word',
            ai: 'AI',
            fallback: 'Not understood',
          },
        },
        ai: {
          rescheduleEnable: 'Reschedule with AI',
          rescheduleHint: 'When the customer asks to reschedule, the system asks for the best day, offers free times and completes the change. Without this, an attendant takes over.',
          searchDays: 'Look for times in the next (days)',
          minNotice: 'Minimum notice (hours)',
          optionsCount: 'Times offered at a time',
          maxRounds: 'Maximum lists before calling an attendant',
          tab: 'Replies and AI',
          intro: 'The replies "1", "2" and "3" are always understood. With the AI on, the system also understands free text, such as "yes, but I will be a bit late".',
          enable: 'Understand free-text replies with AI',
          notConfigured: 'The AI has not been configured in this environment yet. Talk to the system administrator.',
          debounce: 'Wait for consecutive messages (seconds)',
          debounceHint: 'If the customer sends more than one message, the system waits this long and reads everything as a single reply.',
          testTitle: 'Test interpretation',
          testHint: 'Type a customer reply and see how the system would understand it. The test uses the AI even when it is turned off above.',
          customerReply: 'Customer reply',
          simulateCancelQuestion: 'Simulate the answer to the question "Do you confirm the cancellation?"',
          test: 'Test',
          understood: 'Understood',
          unreachable: 'Could not reach the AI.',
          usageTitle: 'Usage in the last 30 days',
          usageSummary: '{{replies}} replies read, {{calls}} AI calls, {{tokens}} tokens, {{errors}} failures.',
        },
        google: {
          tab: 'Google Calendar',
          intro: 'Optional. With a Google calendar connected, each appointment becomes an event in it, and the events already there block the time in the system.',
          notConfigured: 'The Google Calendar integration has not been configured in this environment yet. Talk to the system administrator.',
          revokedHint: 'New appointments are still created and will be sent to Google after you reconnect.',
          connect: 'Connect with Google',
          reconnect: 'Reconnect with Google',
          connectedToast: 'Google account connected. Choose the calendar to use.',
          connectErrorToast: 'Could not connect with Google. Try again.',
          connectedAs: 'Connected as',
          calendar: 'Calendar',
          lastSync: 'Last sync',
          syncNow: 'Sync now',
          synced: 'Sync completed.',
          changeCalendar: 'Change calendar',
          disconnect: 'Disconnect',
          disconnected: 'Google Calendar disconnected.',
          disconnectTitle: 'Disconnect Google Calendar',
          disconnectMessage: 'Appointments stay in the system and events already created in Google are not deleted. The imported busy times stop blocking the schedule.',
          calendarLabel: 'Google calendar',
          primary: 'primary',
          noCalendars: 'No calendar with edit permission was found in this account.',
          syncExisting: 'Send the existing future appointments to Google',
          useCalendar: 'Use this calendar',
          calendarConnected: 'Google calendar connected.',
          busy: 'Busy (Google Calendar)',
          fieldShare: 'Send to the Google Calendar description',
          fieldShareHint: "This field's value appears in the event description. Avoid sensitive data.",
          blockAllDay: 'All-day Google events block the time',
          syncStatus: {
            synced: 'Synced with Google Calendar',
            pending: 'Sending to Google Calendar…',
            error: 'Could not sync with Google Calendar',
            retry: 'Try again',
          },
        },
        title: 'Schedule',
        minutes: '{{minutes}} min',
        yes: 'Yes',
        buttons: {
          reports: 'Reports',
          add: 'New appointment',
          create: 'Add',
          settings: 'Settings',
          schedule: 'Schedule',
          cancel: 'Cancel',
          back: 'Back',
          confirm: 'Confirm',
          reschedule: 'Reschedule',
          attended: 'Attended',
          noShow: 'No-show',
          cancelAppointment: 'Cancel appointment',
          reactivate: 'Reactivate',
          save: 'Save',
        },
        filters: {
          professional: 'Professional',
          allProfessionals: 'All professionals',
          status: 'Status',
          allStatuses: 'All statuses',
          allTypes: 'All types',
        },
        status: {
          pending_confirmation: 'Awaiting confirmation',
          confirmed: 'Confirmed',
          reschedule_requested: 'Reschedule requested',
          cancelled: 'Cancelled',
          completed: 'Attended',
          no_show: 'No-show',
        },
        origin: {
          user: 'User',
          whatsapp: 'Customer (WhatsApp)',
          ai: 'AI',
          google: 'Google Calendar',
          system: 'System',
        },
        calendar: {
          date: 'Date',
          time: 'Time',
          event: 'Appointment',
          allDay: 'All day',
          week: 'Week',
          day: 'Day',
          month: 'Month',
          previous: 'Previous',
          next: 'Next',
          today: 'Today',
          agenda: 'List',
          noEvents: 'There are no appointments in this period.',
        },
        contact: {
          title: 'Schedule',
          upcoming: 'Today and upcoming',
          upcomingTitle: 'Upcoming appointments',
          history: 'History of the last 90 days',
          historyEmpty: 'No other appointments in the last 90 days.',
          empty: 'This contact has no upcoming appointment.',
          schedule: 'Schedule',
          newAppointment: 'New appointment',
          nextAppointment: 'Next appointment: {{when}}',
          loadHistory: 'Load history',
          hideHistory: 'Hide history',
          today: 'Today',
          tomorrow: 'Tomorrow',
          yesterday: 'Yesterday',
          close: 'Close',
        },
        modal: {
          addTitle: 'New appointment',
        },
        form: {
          professional: 'Professional',
          selectProfessional: 'Select the professional',
          contact: 'Contact',
          contactHelp: 'Type at least 3 letters to search',
          contactPrefilled: 'Filled in from the conversation. You can change it if needed.',
          addContact: 'Add',
          type: 'Appointment type',
          date: 'Date',
          time: 'Time',
          noSlots: "No free times on this day. Check the company's business hours or pick another date.",
          notes: 'Notes',
        },
        reschedule: {
          title: 'Reschedule',
          hint: 'After rescheduling, the appointment goes back to "Awaiting confirmation".',
        },
        reactivate: {
          title: 'Reactivate appointment',
          hint: 'The appointment comes back at the same time, waiting for the customer to confirm. For another time, reactivate it and then reschedule.',
          note: 'Reason (optional)',
          notify: 'Ask the customer to confirm by WhatsApp',
        },
        cancel: {
          title: 'Cancel appointment',
          reason: 'Reason (optional)',
        },
        drawer: {
          professional: 'Professional',
          status: 'Status',
          dateTime: 'Date and time',
          scheduledBy: 'Scheduled by',
          cancelReason: 'Cancellation reason',
          history: 'History',
          rescheduledFromTo: 'Rescheduled from {{from}} to {{to}}',
        },
        toasts: {
          created: 'Appointment created successfully.',
          rescheduled: 'Appointment rescheduled successfully.',
          cancelled: 'Appointment cancelled.',
          statusUpdated: 'Status updated.',
          reactivated: 'Appointment reactivated.',
        },
        settings: {
          professionals: {
            intro: 'Optional. Register the professionals who see patients so each one has their own calendar. With any active professional, every appointment needs a professional.',
            add: 'New professional',
            empty: 'No professionals registered. The calendar stays single, with no professional to choose.',
            name: 'Name',
            googleCalendar: 'Google calendar',
            googleHelp: 'Without a personal calendar, appointments use the clinic calendar when available.',
            noGoogleCalendar: 'Use clinic calendar',
            systemOnly: 'Clinic calendar or system only',
            addTitle: 'New professional',
            editTitle: 'Edit professional',
            deleteTitle: 'Delete professional',
            deleteMessage: 'Do you want to delete the professional "{{name}}"? Professionals with appointments cannot be deleted; deactivate them instead.',
            deleted: 'Professional deleted successfully.',
            saved: 'Professional saved successfully.',
          },
          title: 'Schedule settings',
          subtitle: 'Define how the schedule works: appointment types, professionals, fields, integrations, notifications and rules.',
          active: 'Active',
          inactive: 'Inactive',
          actions: 'Actions',
          tabs: {
            professionals: 'Professionals',
            types: 'Appointment types',
            fields: 'Fields',
            rules: 'Rules',
          },
          types: {
            intro: 'Define the appointment types, such as consultation, follow-up or evaluation, and the duration of each.',
            add: 'New type',
            empty: 'No appointment types registered. Create at least one to be able to schedule.',
            name: 'Name',
            duration: 'Duration (minutes)',
            durationShort: 'Duration',
            durationOptions: {
              minutes: '{{minutes}} minutes',
              hour: '1 hour',
              hours: '{{hours}} hours',
              hoursMinutes: '{{hours}}h{{minutes}}',
              custom: 'Custom',
              customHelp: 'Enter 5 to 480 minutes.',
            },
            color: 'Color',
            addTitle: 'New appointment type',
            editTitle: 'Edit appointment type',
            deleteTitle: 'Delete appointment type',
            deleteMessage: 'Delete the type "{{name}}"? Types already used in appointments cannot be deleted; deactivate them instead.',
            saved: 'Appointment type saved successfully.',
            deleted: 'Appointment type deleted successfully.',
          },
          fields: {
            intro: 'Besides the contact, these fields are filled in on every appointment. Use the arrows to change the order.',
            add: 'New field',
            empty: 'No additional fields registered.',
            label: 'Field name',
            type: 'Type',
            options: 'Options (one per line)',
            required: 'Required',
            addTitle: 'New field',
            editTitle: 'Edit field',
            deleteTitle: 'Delete field',
            deleteMessage: 'Delete the field "{{name}}"? Existing appointments keep the value that was filled in.',
            saved: 'Field saved successfully.',
            deleted: 'Field deleted successfully.',
            moveUp: 'Move up',
            moveDown: 'Move down',
            types: {
              text: 'Short text',
              textarea: 'Long text',
              number: 'Number',
              date: 'Date',
              select: 'Option list',
              checkbox: 'Checkbox',
            },
          },
          rules: {
            slotInterval: 'Interval between times (minutes)',
            defaultDuration: 'Default duration of new types (minutes)',
            hint: "Free times follow the company's business hours, set in Settings.",
            saved: 'Settings saved successfully.',
          },
        },
      },
      signup: {
        title: 'Sign Up',
        toasts: {
          success: 'User created successfully! Please log in.',
          fail: 'Error creating user. Please check the provided data.',
        },
        form: {
          name: 'Name',
          email: 'Email',
          password: 'Password',
        },
        buttons: {
          submit: 'Register',
          login: 'Already have an account? Log in!',
        },
      },
      login: {
        title: 'Login',
        form: {
          email: 'Email',
          password: 'Password',
        },
        buttons: {
          submit: 'Log In',
          register: 'Register now!',
        },
      },
      plans: {
        form: {
          name: 'Name',
          users: 'Users',
          connections: 'Connections',
          campaigns: 'Campaigns',
          schedules: 'Schedules',
          crm: 'CRM',
          enabled: 'Enabled',
          disabled: 'Disabled',
          clear: 'Cancel',
          delete: 'Delete',
          save: 'Save',
          yes: 'Yes',
          no: 'No',
          money: '$',
        },
      },
      companies: {
        title: 'Register Company',
        form: {
          name: 'Company Name',
          plan: 'Plan',
          token: 'Token',
          submit: 'Register',
          success: 'Company created successfully!',
        },
      },
      auth: {
        toasts: {
          success: 'Login successful!',
        },
        token: 'Token',
      },
      dashboard: {
        charts: {
          ticketsCreated: 'Tickets created: ',
          tickets: 'Tickets',
          perDay: {
            title: 'Tickets today: ',
          },
        },
        filters: {
          dateFrom: 'Start date',
          dateTo: 'End date',
          period: 'Period',
          noneSelected: 'None selected',
          last3Days: 'Last 3 days',
          last7Days: 'Last 7 days',
          last15Days: 'Last 15 days',
          last30Days: 'Last 30 days',
          last60Days: 'Last 60 days',
          last90Days: 'Last 90 days',
          filterType: 'Filter type',
          dateFilter: 'Date filter',
          periodFilter: 'Period filter',
          filter: 'Filter',
        },
        cards: {
          activeConnections: 'Active Connections',
          companies: 'Companies',
          inConversation: 'In Conversation',
          waiting: 'Waiting',
          newContacts: 'New Contacts',
          avgConversationTime: 'Avg. Conversation Time',
          finished: 'Finished',
          avgWaitTime: 'Avg. Wait Time',
        },
        messages: {
          parameterizeFilter: 'Set at least one filter',
        },
        awaitingResponse: {
          title: 'Tickets without response',
          subtitle: 'Current backlog where the latest message came from the contact inside the filtered period.',
          chartTitle: 'Daily evolution of tickets without response',
          open: 'Open',
          pending: 'Pending',
          empty: 'No tickets without response were found for the selected period.',
        },
        userRatings: {
          title: 'Rated tickets - {{name}}',
          subtitle: 'Ratings received in the period filtered on the dashboard.',
          openRatings: 'View rated tickets',
          contact: 'Contact',
          queue: 'Queue',
          rate: 'Rating',
          ratedAt: 'Rated at',
          viewMessages: 'View messages',
          empty: 'No rated tickets in the filtered period.',
          noQueue: 'No queue',
          close: 'Close',
        },
      },
      connections: {
        title: 'Connections',
        toasts: {
          deleted: 'WhatsApp connection deleted successfully!',
          disconnected: 'WhatsApp session disconnected successfully.',
          connecting: 'Starting WhatsApp session. Wait for the QR Code.',
          requestingQr: 'Requesting a new QR Code. Wait for the update.',
        },
        confirmationModal: {
          deleteTitle: 'Delete',
          deleteMessage: 'Are you sure? This action cannot be undone.',
          disconnectTitle: 'Disconnect',
          disconnectMessage: "Are you sure? You'll need to scan the QR Code again.",
        },
        buttons: {
          add: 'Add WhatsApp',
          disconnect: 'Disconnect',
          tryAgain: 'Try Again',
          qrcode: 'QR CODE',
          newQr: 'New QR CODE',
          pairingCode: 'Code',
          connecting: 'Connecting',
          restart: 'Restart',
        },
        toolTips: {
          disconnected: {
            title: 'Failed to start WhatsApp session',
            content: 'Make sure your phone is connected to the internet and try again, or request a new QR Code',
          },
          qrcode: {
            title: 'Waiting for QR Code scan',
            content: "Click the 'QR CODE' button and scan the QR Code with your phone to start the session",
          },
          connected: {
            title: 'Connection established!',
          },
          timeout: {
            title: 'Connection with phone lost',
            content: "Make sure your phone is connected to the internet and WhatsApp is open, or click the 'Disconnect' button to get a new QR Code",
          },
        },
        table: {
          name: 'Name',
          number: 'Number',
          status: 'Status',
          lastUpdate: 'Last Update',
          default: 'Default',
          actions: 'Actions',
          session: 'Session',
        },
      },
      groupParticipants: {
        title: 'Group participants',
        subtitle: 'Manage WhatsApp group members linked to your connections.',
        form: {
          whatsapp: 'WhatsApp connection',
          group: 'Group',
          groupPlaceholder: 'Select a group',
          loadingGroups: 'Loading groups...',
          noGroups: 'No groups available for this connection.',
          load: 'Load participants',
        },
        placeholder: 'Select a connection and group to load participants.',
        emptyState: 'No participants found for this group.',
        groupIdLabel: 'Group ID: {{groupId}}',
        groupSizeLabel: 'Members: {{size}}',
        table: {
          participant: 'Participant',
          number: 'Number',
          admin: 'Role',
          actions: 'Actions',
          unknown: 'Unknown name',
          superAdmin: 'Super admin',
          adminLabel: 'Admin',
          member: 'Member',
        },
        addParticipants: {
          title: 'Add participants',
          helper: 'Enter one full number (country/area code + number) or JID per line, or pick existing contacts below. You may also separate values with commas or semicolons.',
          placeholder: '5511999999999\n5511888888888@s.whatsapp.net',
          button: 'Add to group',
          contactsLabel: 'Select existing contacts',
          contactsPlaceholder: 'Type to search contacts',
          contactsNoOptions: 'No contacts found with this search.',
          contactsLoading: 'Loading contacts...',
        },
        createGroup: {
          title: 'Create a new group',
          subtitle: 'Set the subject and choose the first participants to create a group on the selected connection.',
          openButton: 'Create group',
          subjectLabel: 'Group subject',
          subjectPlaceholder: 'Ex.: Support team',
          contactsLabel: 'Add existing contacts',
          contactsPlaceholder: 'Type to search contacts',
          contactsNoOptions: 'No contacts found with this search.',
          contactsLoading: 'Loading contacts...',
          numbersPlaceholder: '5511999999999\n5511888888888@s.whatsapp.net',
          button: 'Create group',
          cancel: 'Cancel',
          toasts: {
            missingWhatsapp: 'Select the connection to create the group.',
            subjectRequired: 'Enter a subject to create the group.',
            noNumbers: 'Add at least one number or contact to continue.',
            success: 'Group created successfully.',
          },
        },
        actions: {
          remove: 'Remove participant',
          refresh: 'Refresh list',
        },
        confirmation: {
          removeParticipant: 'Remove {{number}} from the group?',
        },
        toasts: {
          missingInformation: 'Select a connection and group.',
          loadSuccess: 'Participants updated successfully.',
          noNumbers: 'Provide at least one number or contact to continue.',
          addSuccess: 'Participants added successfully.',
          removeSuccess: 'Participant removed successfully.',
        },
      },
      whatsappModal: {
        title: {
          add: 'Add WhatsApp',
          edit: 'Edit WhatsApp',
        },
        tabs: {
          general: 'General',
          messages: 'Messages',
          assessments: 'Assessments',
          integrations: 'Integrations',
          schedules: 'Business Hours',
        },
        form: {
          name: 'Name',
          default: 'Default',
          sendIdQueue: 'Queue',
          timeSendQueue: 'Redirect to queue after X minutes',
          queueRedirection: 'Queue Redirection',
          outOfHoursMessage: 'Out of hours message',
          queueRedirectionDesc: 'Select a queue for contacts without a queue to be redirected to',
          agent: 'Agent',
          noAgent: 'No agent',
          agentTestModeHint: 'This agent is in test mode. Only whitelist numbers will use the agent; everyone else will continue through the normal queue chatbot flow.',
          agentLiveModeHint: 'This agent is live for the whole connection. While linked here, it will answer before the normal chatbot flow.',
          expiresTicket: 'Close open chats after X minutes',
          expiresInactiveMessage: 'Inactivity closure message',
          greetingMessage: 'Greeting message',
          complationMessage: 'Completion message',
        },
        buttons: {
          okAdd: 'Add',
          okEdit: 'Save',
          cancel: 'Cancel',
          generateApiToken: 'Generate API Token',
        },
        success: 'WhatsApp saved successfully.',
        toasts: {
          tokenCopied: 'Token copied to clipboard!',
          variableCopied: 'Variable copied to clipboard!',
        },
      },
      qrCode: {
        message: 'Scan the QrCode to start the session',
      },
      qrCodeModal: {
        title: 'QrCode',
        connectTitle: 'Connect to WhatsApp Web',
        waiting: 'Waiting for QR Code generation...',
        loadingQr: 'Loading QR Code...',
        emptyTitle: 'QR Code has not been generated yet',
        emptyHelper: 'Start a new generation to connect with the WhatsApp camera.',
        generateQrButton: 'Generate QR Code',
        refreshesIn: 'Refreshes in:',
        expiresSoon: 'The QR Code expires soon.',
        tabs: {
          qrCode: 'QR Code',
          pairingCode: 'Code',
        },
        qrInstructions: {
          openWhatsApp: 'Open WhatsApp on your phone',
          openSettings: 'Go to Menu or Settings',
          linkedDevices: 'Select Linked devices',
          scanQrCode: 'Point the camera at the QR Code',
        },
        pairing: {
          countryCodeLabel: 'Code',
          phoneLabel: 'WhatsApp number',
          phonePlaceholder: '4155551234',
          phoneHelper: 'Enter area code and number. Use digits only.',
          invalidPhone: 'Enter a valid number with country code and digits only.',
          generateButton: 'Generate code',
          codeHelper: 'On your phone, choose Link with phone number and enter this code.',
          instructions: {
            openWhatsApp: 'Open WhatsApp on your phone',
            linkDevice: 'Go to Linked devices and tap Link a device',
            enterCode: 'Choose link with phone number and enter the generated code',
          },
        },
      },
      contacts: {
        title: 'Contacts',
        toasts: {
          deleted: 'Contact deleted successfully!',
          deletedAll: 'All contacts deleted successfully!',
        },
        searchPlaceholder: 'Search...',
        confirmationModal: {
          deleteTitle: 'Delete ',
          deleteAllTitle: 'Delete All',
          importTitle: 'Import contacts',
          deleteMessage: 'Are you sure you want to delete this contact? All related tickets will be lost.',
          deleteAllMessage: 'Are you sure you want to delete all contacts? All related tickets will be lost.',
          importMessage: 'Do you want to import all contacts from your phone?',
        },
        // TODO non used - duplicated
        // confirmationModal: {
        //   importTitlte: 'Import contacts',
        //   importMessage:
        //     'This action will import contacts saved in your WhatsApp address book.
        // Some models may not allow this functionality or according to your privacy settings! Check the result within 1 hour.',
        //   deleteTitle: 'Delete',
        //   deleteMessage: 'Are you sure you want to delete this contact? All related tickets will be lost.',
        // },
        buttons: {
          import: 'Import Contacts',
          importSheet: 'Import Excel',
          add: 'Add Contact',
          export: 'Export Contacts',
          delete: 'Delete All Contacts',
        },
        table: {
          name: 'Name',
          whatsapp: 'WhatsApp',
          email: 'Email',
          actions: 'Actions',
        },
      },
      queueIntegrationModal: {
        title: {
          add: 'Add project',
          edit: 'Edit project',
        },
        form: {
          id: 'ID',
          type: 'Type',
          name: 'Name',
          projectName: 'Project Name',
          language: 'Language',
          jsonContent: 'JsonContent',
          urlN8N: 'URL',
          typebotSlug: 'Typebot - Slug',
          typebotExpires: 'Time in minutes to expire a conversation',
          typebotKeywordFinish: 'Keyword to finish ticket',
          typebotKeywordRestart: 'Keyword to restart flow',
          typebotRestartMessage: 'Message when restarting conversation',
          typebotUnknownMessage: 'Invalid option message',
          typebotDelayMessage: 'Interval (ms) between messages',
        },
        buttons: {
          okAdd: 'Add',
          okEdit: 'Save',
          cancel: 'Cancel',
          test: 'Test Bot',
        },
        messages: {
          testSuccess: 'Integration tested successfully!',
          addSuccess: 'Integration added successfully.',
          editSuccess: 'Integration edited successfully.',
        },
      },
      sideMenu: {
        name: 'Initial Side Menu',
        note: 'If enabled, the side menu will start closed',
        options: {
          enabled: 'Open',
          disabled: 'Closed',
        },
      },
      promptModal: {
        form: {
          name: 'Name',
          prompt: 'Prompt',
          testNumbers: 'Phone numbers allowed for testing',
          testNumbersPlaceholder: 'Example: 5511999999999, 5511888888888',
          testNumbersHelp: 'Separate phone numbers with commas. When filled, only those numbers will enter the live prompt flow.',
          fallbackQueue: 'Default queue when the agent cannot answer',
          transferQueues: 'Queues the agent may transfer to by topic',
          voice: 'Voice',
          max_tokens: 'Maximum Tokens in response',
          temperature: 'Temperature',
          apikey: 'API Key',
          max_messages: 'Maximum messages in History',
          voiceKey: 'Voice API Key',
          voiceRegion: 'Voice Region',
        },
        success: 'Prompt saved successfully!',
        title: {
          add: 'Add Agent',
          edit: 'Edit Agent',
        },
        buttons: {
          okAdd: 'Add',
          okEdit: 'Save',
          cancel: 'Cancel',
        },
      },
      prompts: {
        title: 'Agent',
        table: {
          name: 'Name',
          queue: 'Department/Queue',
          max_tokens: 'Maximum Response Tokens',
          actions: 'Actions',
        },
        confirmationModal: {
          deleteTitle: 'Delete',
          deleteMessage: 'Are you sure? This action cannot be undone!',
        },
        buttons: {
          add: 'Add Agent',
          test: 'Test agent',
          edit: 'Edit agent',
          delete: 'Delete agent',
        },
        testChat: {
          title: 'Agent test chat',
          modalTitle: 'Agent simulator',
          topline: 'Validation environment',
          queueLabel: 'Transfer queue',
          emptyTitle: 'Choose a prompt to test',
          emptyDescription: 'Use the test action in the table to open a simulated conversation with the agent.',
          startTitle: 'Conversation ready for testing',
          startDescription: 'Send a message and the backend will reply using the saved prompt and settings.',
          emptyConversation: 'There are no messages in this simulation yet. Send the first prompt to validate the agent behavior.',
          inputLabel: 'Your message',
          inputPlaceholder: 'Example: I want to cancel my order and speak to a human agent.',
          send: 'Send',
          close: 'Close',
          clear: 'Clear chat',
          historyHint: 'This test uses up to {{count}} messages from the simulated agent history.',
          footerHint: 'Responses here do not create tickets or transfer any real conversation.',
          you: 'You',
          agent: 'Agent',
          transferBadge: 'Transfer suggested',
        },
      },
      contactModal: {
        title: {
          add: 'Add contact',
          edit: 'Edit contact',
        },
        form: {
          mainInfo: 'Contact details',
          extraInfo: 'Additional information',
          name: 'Name',
          number: 'Whatsapp Number',
          birthday: 'Birthday',
          email: 'Email',
          extraName: 'Field name',
          extraValue: 'Value',
          disableBot: 'Disable chatbot',
          whatsapp: 'Source Connection: ',
          leadSource: {
            label: 'Lead source',
            unset: 'Set lead source',
            instagram: 'Instagram',
            facebook: 'Facebook',
            google_ads: 'Google Ads',
            youtube: 'YouTube',
            ai: 'AI (ChatGPT/other)',
            whatsapp: 'WhatsApp direct',
            referral: 'Referral',
            site: 'Website',
            other: 'Other',
          },
        },
        buttons: {
          addExtraInfo: 'Add information',
          okAdd: 'Add',
          okEdit: 'Save',
          cancel: 'Cancel',
        },
        success: 'Contact saved successfully.',
      },
      queueModal: {
        title: {
          add: 'Add queue',
          edit: 'Edit queue',
        },
        toasts: {
          deleted: 'Record deleted',
        },
        confirmationModal: {
          deleteTitle: 'Delete',
          deleteMessage: 'This action cannot be undone.',
        },
        form: {
          name: 'Name',
          color: 'Color',
          greetingMessage: 'Greeting message',
          complationMessage: 'Completion message',
          outOfHoursMessage: 'Out of hours message',
          ratingMessage: 'Rating message',
          token: 'Token',
          orderQueue: 'Queue order (Bot)',
          integrationId: 'Integration',
          tagsToAdd: 'Tags to add',
          tagsToRemove: 'Tags to remove',
        },
        buttons: {
          okAdd: 'Add',
          okEdit: 'Save',
          cancel: 'Cancel',
          attach: 'Attach File',
        },
        serviceHours: {
          dayWeek: 'Weekday',
          startTimeA: 'Start Time - 1',
          endTimeA: 'End Time - 1',
          startTimeB: 'Start Time - 2',
          endTimeB: 'End Time - 2',
          monday: 'Monday',
          tuesday: 'Tuesday',
          wednesday: 'Wednesday',
          thursday: 'Thursday',
          friday: 'Friday',
          saturday: 'Saturday',
          sunday: 'Sunday',
        },
      },
      userModal: {
        title: {
          add: 'Add user',
          edit: 'Edit user',
        },
        form: {
          name: 'Name',
          email: 'Email',
          password: 'Password',
          cpf: 'CPF',
          profile: 'Profile',
          whatsapp: 'Default Connection',
          whatsapps: 'Allowed connections',
          whatsappsHelper: 'Leave empty to allow all connections',

          allTicket: 'Queue-less Ticket [Invisible]',
          allTicketEnabled: 'Enabled',
          allTicketDesabled: 'Disabled',
          viewAllTickets: 'View All Queue Tickets',
          viewAllTicketsEnabled: 'Enabled',
          viewAllTicketsDesabled: 'Disabled',
        },
        buttons: {
          okAdd: 'Add',
          okEdit: 'Save',
          cancel: 'Cancel',
        },
        success: 'User saved successfully.',
      },
      scheduleModal: {
        title: {
          add: 'New Schedule',
          edit: 'Edit Schedule',
        },
        form: {
          body: 'Message',
          contact: 'Contact',
          sendAt: 'Schedule Date',
          sentAt: 'Send Date',
        },
        buttons: {
          okAdd: 'Add',
          okEdit: 'Save',
          cancel: 'Cancel',
        },
        success: 'Schedule saved successfully.',
        validation: {
          pastDate: 'Schedule time must be in the future.',
          invalidDate: 'Invalid schedule date or time.',
        },
        daySelectionInfo: 'Select the weekdays when the message should be sent.',
        recurringEditInfo: 'This is a recurring schedule. Changes will only affect future sends.',
        recurringEditSingleInfo: 'This message is part of a recurring schedule. Changes will apply only to this entry. Edit the main schedule to update all.',
      },
      tagModal: {
        title: {
          add: 'New Tag',
          edit: 'Edit Tag',
        },
        form: {
          name: 'Name',
          color: 'Color',
        },
        buttons: {
          okAdd: 'Add',
          okEdit: 'Save',
          cancel: 'Cancel',
        },
        success: 'Tag saved successfully.',
      },
      chat: {
        noTicketMessage: 'Select a ticket to start chatting.',
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop: 'DRAG AND DROP FILES IN THE FIELD BELOW',
          titleFileList: 'File list',
        },
      },
      ticketsManager: {
        buttons: {
          newTicket: 'New',
          closeallTicket: 'Close',
        },
      },
      ticketsQueueSelect: {
        placeholder: 'Queues',
      },
      ticketsWhatsappSelect: {
        placeholder: 'Connections',
      },
      tickets: {
        inbox: {
          closedAllTickets: 'Close all tickets?',
          closedAll: 'Close All',
          newTicket: 'New Ticket',
          yes: 'YES',
          no: 'NO',
          open: 'Open',
          resolverd: 'Resolved',
        },
        toasts: {
          deleted: 'The ticket you were viewing has been deleted.',
        },
        notification: {
          message: 'Message from',
        },
        tabs: {
          open: { title: 'Open' },
          closed: { title: 'Closed' },
          search: { title: 'Search' },
        },
        search: {
          placeholder: 'Search tickets and messages',
          filterConnections: 'Connection filter',
          filterContacts: 'Contact filter',
          filterConections: 'Connection Filter',
          filterConectionsOptions: {
            open: 'Open',
            closed: 'Closed',
            pending: 'Pending',
          },
          filterUsers: 'User filter',
          ticketsPerPage: 'Tickets per page',
        },
        buttons: {
          showAll: 'All',
        },
      },
      transferTicketModal: {
        title: 'Transfer Ticket',
        fieldLabel: 'Type to search users',
        fieldQueueLabel: 'Transfer to queue',
        fieldQueuePlaceholder: 'Select a queue',
        noOptions: 'No user found with this name',
        buttons: {
          ok: 'Transfer',
          cancel: 'Cancel',
        },
      },
      ticketsList: {
        called: 'Called',
        pendingHeader: 'Waiting',
        assignedHeader: 'Attending',
        awaitingResponseToggle: 'Awaiting response',
        noTicketsTitle: 'Nothing here!',
        noTicketsMessage: 'No tickets found with this status or search term',
        noAwaitingResponseTitle: 'No tickets awaiting reply',
        noAwaitingResponseMessage: 'No open ticket currently has the contact as the latest message waiting for an agent reply.',
        sort: {
          newestFirst: 'Newest first. Click to show the oldest conversations.',
          oldestFirst: 'Oldest first. Click to show the newest conversations.',
        },
        buttons: {
          accept: 'Accept',
          closed: 'Finish',
          transfer: 'Transfer',
          reopen: 'Reopen',
          exportAsPDF: 'Export as PDF',
        },
        pendingEvaluationTag: 'Pending evaluation',
        pendingEvaluationModal: {
          title: 'Ticket awaiting evaluation',
          message: 'If you finish now, the evaluation may not be counted and this action may go against company guidelines. Do you still want to finish?',
        },
      },
      newTicketModal: {
        title: 'Create Ticket',
        fieldLabel: 'Type to search contact',
        add: 'Add',
        buttons: {
          ok: 'Save',
          cancel: 'Cancel',
        },
      },
      mainDrawer: {
        sections: {
          atendimento: 'Service',
          gerencia: 'Management',
          campanhas: 'Campaigns',
          administracao: 'Administration',
          sistema: 'System',
        },
        listItems: {
          dashboard: 'Dashboard',
          kanban: 'Kanban',
          connections: 'Connections',
          groupParticipants: 'Group participants',
          tickets: 'Tickets',
          quickMessages: 'Quick Responses',
          tasks: 'Tasks',
          contacts: 'Contacts',
          queues: 'Queues & Chatbot',
          tags: 'Tags',
          administration: 'Administration',
          users: 'Users',
          settings: 'Settings',
          helps: 'Help',
          messagesAPI: 'API',
          schedules: 'Schedules',
          agenda: 'Schedule',
          campaigns: 'Campaigns',
          annoucements: 'Announcements',
          backups: 'Backups',
          loglauncher: 'Updates',
          chats: 'Internal Chat',
          financeiro: 'Financial',
          files: 'File list',
          prompts: 'Open.Ai',
          reports: 'Reports',
          queueIntegration: 'Integrations',
          listagem: 'Listing',
          contactLists: 'Contact Lists',
          campaignsConfig: 'Settings',
        },
        appBar: {
          notRegister: 'No notifications',
          user: {
            profile: 'Profile',
            logout: 'Logout',
          },
          impersonation: {
            banner: 'You are accessing {{company}} as an administrator.',
            back: 'Back to master access',
            enter: 'Access as administrator',
          },
        },
      },
      queueIntegration: {
        title: 'Integrations',
        table: {
          id: 'ID',
          type: 'Type',
          name: 'Name',
          projectName: 'Project Name',
          language: 'Language',
          lastUpdate: 'Last update',
          actions: 'Actions',
        },
        buttons: {
          add: 'Add Project',
        },
        searchPlaceholder: 'Search...',
        confirmationModal: {
          deleteTitle: 'Delete',
          deleteMessage: 'Are you sure? This action cannot be undone! and will be removed from linked queues and connections',
        },
        toasts: {
          deleted: 'Integration deleted successfully!',
        },
      },
      reports: {
        title: 'Ticket Reports',
        table: {
          id: 'Ticket',
          user: 'User',
          dateOpen: 'Open Date',
          dateClose: 'Close Date',
          NPS: 'NPS',
          status: 'Status',
          whatsapp: 'Connection',
          queue: 'Queue',
          actions: 'Actions',
          lastMessage: 'Last Message',
          contact: 'Customer',
          supportTime: 'Support Time',
        },
        buttons: {
          filter: 'Apply Filter',
        },
        searchPlaceholder: 'Search...',
      },
      files: {
        title: 'File list',
        table: {
          name: 'Name',
          contacts: 'Contacts',
          actions: 'Action',
        },
        toasts: {
          deleted: 'List deleted successfully!',
          deletedAll: 'All lists deleted successfully!',
        },
        buttons: {
          add: 'Add',
          deleteAll: 'Delete All',
        },
        confirmationModal: {
          deleteTitle: 'Delete',
          deleteAllTitle: 'Delete All',
          deleteMessage: 'Are you sure you want to delete this list?',
          deleteAllMessage: 'Are you sure you want to delete all lists?',
        },
      },
      languages: {
        undefined: 'Language',
        'pt-BR': 'Portuguese',
        es: 'Spanish',
        en: 'English',
        tr: 'Turkish',
      },
      messagesAPI: {
        title: 'API',
        textMessage: {
          number: 'Number',
          body: 'Message',
          token: 'Registered token',
        },
        mediaMessage: {
          number: 'Number',
          body: 'File name',
          media: 'File',
          token: 'Registered token',
        },
      },
      notifications: {
        noTickets: 'No notifications.',
      },
      quickMessages: {
        title: 'Quick Responses',
        searchPlaceholder: 'Search...',
        noAttachment: 'No attachment',
        confirmationModal: {
          deleteTitle: 'Deletion',
          deleteMessage: 'This action is irreversible! Do you want to proceed?',
        },
        sendConfirm: {
          title: 'Send quick response',
          message: 'Are you sure you want to send this message?',
          dontShowAgain: "Don't show again",
          enable: 'Confirm quick response send',
        },
        buttons: {
          add: 'Add',
          attach: 'Attach File',
          cancel: 'Cancel',
          edit: 'Edit',
        },
        toasts: {
          success: 'Shortcut added successfully!',
          deleted: 'Shortcut removed successfully!',
        },
        dialog: {
          title: 'Quick Message',
          shortcode: 'Shortcut',
          message: 'Response',
          save: 'Save',
          cancel: 'Cancel',
          add: 'Add',
          edit: 'Edit',
          visao: 'Allow view',
          geral: 'Global',
          active: 'Active',
          inactive: 'Inactive',
          editBeforeSend: 'Edit before sending',
        },
        validation: {
          required: 'Required',
        },
        table: {
          shortcode: 'Shortcut',
          message: 'Message',
          actions: 'Actions',
          mediaName: 'File Name',
          status: 'Global',
        },
      },
      messageVariablesPicker: {
        label: 'Available variables',
        vars: {
          contactFirstName: 'First Name',
          contactName: 'Name',
          greeting: 'Greeting',
          protocolNumber: 'Protocol',
          date: 'Date',
          hour: 'Time',
        },
      },
      contactLists: {
        title: 'Contact Lists',
        table: {
          name: 'Name',
          contacts: 'Contacts',
          actions: 'Actions',
        },
        buttons: {
          add: 'New List',
        },
        dialog: {
          name: 'Name',
          company: 'Company',
          okEdit: 'Edit',
          okAdd: 'Add',
          add: 'Add',
          edit: 'Edit',
          cancel: 'Cancel',
        },
        confirmationModal: {
          deleteTitle: 'Delete',
          deleteMessage: 'This action cannot be undone.',
        },
        toasts: {
          deleted: 'Record deleted',
        },
      },
      contactListItems: {
        title: 'Contacts',
        searchPlaceholder: 'Search',
        buttons: {
          add: 'New',
          lists: 'Lists',
          import: 'Import',
        },
        dialog: {
          name: 'Name',
          number: 'Number',
          whatsapp: 'Whatsapp',
          email: 'E-mail',
          selectContact: 'Select contact',
          selectContactPlaceholder: 'Search for an existing contact',
          noOptions: 'No contacts found',
          okEdit: 'Edit',
          okAdd: 'Add',
          add: 'Add',
          edit: 'Edit',
          cancel: 'Cancel',
        },
        table: {
          name: 'Name',
          number: 'Number',
          whatsapp: 'Whatsapp',
          email: 'E-mail',
          actions: 'Actions',
        },
        confirmationModal: {
          deleteTitle: 'Delete',
          deleteMessage: 'This action cannot be undone.',
          importMessage: 'Do you want to import contacts from this spreadsheet? ',
          importTitlte: 'Import',
        },
        toasts: {
          deleted: 'Record deleted',
        },
      },
      campaigns: {
        title: 'Campaigns',
        searchPlaceholder: 'Search',
        buttons: {
          add: 'New Campaign',
          contactLists: 'Contact Lists',
          details: 'Details',
        },
        table: {
          name: 'Name',
          whatsapp: 'Connection',
          contactList: 'Contact List',
          status: 'Status',
          scheduledAt: 'Scheduled',
          completedAt: 'Completed',
          confirmation: 'Confirmation',
          actions: 'Actions',
        },
        dialog: {
          new: 'New Campaign',
          update: 'Edit Campaign',
          readonly: 'View Only',
          form: {
            name: 'Name',
            message1: 'Message 1',
            message2: 'Message 2',
            message3: 'Message 3',
            message4: 'Message 4',
            message5: 'Message 5',
            confirmationMessage1: 'Confirmation Message 1',
            confirmationMessage2: 'Confirmation Message 2',
            confirmationMessage3: 'Confirmation Message 3',
            confirmationMessage4: 'Confirmation Message 4',
            confirmationMessage5: 'Confirmation Message 5',
            messagePlaceholder: 'Message content',
            whatsapp: 'Connection',
            status: 'Status',
            scheduledAt: 'Scheduled',
            confirmation: 'Confirmation',
            audienceTitle: 'Campaign recipients',
            audienceDescription: 'Choose an existing list or use a tag to automatically build the audience from contacts with tagged tickets.',
            contactList: 'Manual contact list',
            contactListHelper: 'Used when no tag audience is selected.',
            contactListIgnoredHelper: 'This list will be ignored because the audience will be built from the selected tag.',
            tagList: 'Audience by tag',
            tagListHelper: 'Optional. When you choose a tag, the campaign uses contacts from tickets that have that tag.',
            tagListSelectedHelper: 'The campaign will create an automatic list with the contacts found for this tag.',
            fileList: 'File List',
          },
          buttons: {
            add: 'Add',
            edit: 'Update',
            okadd: 'Ok',
            cancel: 'Cancel Sends',
            restart: 'Restart Sends',
            close: 'Close',
            attach: 'Attach File',
            report: 'View Report',
          },
        },
        confirmationModal: {
          deleteTitle: 'Delete',
          deleteMessage: 'This action cannot be undone.',
        },
        toasts: {
          success: 'Operation performed successfully',
          cancel: 'Campaign canceled',
          restart: 'Campaign restarted',
          deleted: 'Record deleted',
        },
      },
      announcements: {
        active: 'Active',
        inactive: 'Inactive',
        title: 'Announcements',
        searchPlaceholder: 'Search',
        buttons: {
          add: 'New Announcement',
          contactLists: 'Announcement Lists',
        },
        table: {
          priority: 'Priority',
          title: 'Title',
          text: 'Text',
          mediaName: 'File',
          status: 'Status',
          actions: 'Actions',
        },
        dialog: {
          edit: 'Edit Announcement',
          add: 'New Announcement',
          update: 'Edit Announcement',
          readonly: 'View Only',
          form: {
            priority: 'Priority',
            title: 'Title',
            text: 'Text',
            mediaPath: 'File',
            status: 'Status',
          },
          buttons: {
            add: 'Add',
            edit: 'Update',
            okadd: 'Ok',
            cancel: 'Cancel',
            close: 'Close',
            attach: 'Attach File',
          },
        },
        confirmationModal: {
          deleteTitle: 'Delete',
          deleteMessage: 'This action cannot be undone.',
        },
        toasts: {
          success: 'Operation performed successfully',
          deleted: 'Record deleted',
        },
      },
      campaignsConfig: {
        title: 'Campaign Settings',
      },
      queues: {
        title: 'Queues & Chatbot',
        table: {
          id: 'ID',
          name: 'Name',
          color: 'Color',
          greeting: 'Greeting message',
          actions: 'Actions',
          orderQueue: 'Queue order (bot)',
        },
        buttons: {
          add: 'Add queue',
          flow: 'View bot flow',
          test: 'Test bot flow',
        },
        confirmationModal: {
          deleteTitle: 'Delete',
          deleteMessage: "Are you sure? This action cannot be undone! Tickets in this queue will continue to exist but won't have any queue assigned.",
        },
        flow: {
          title: 'Bot Flow',
          autoArrange: 'Auto arrange',
          exportImage: 'Export image',
        },
        test: {
          title: 'Bot flow test',
          placeholder: 'Type a message',
          send: 'Send',
          close: 'Close',
        },
      },
      queueSelect: {
        inputLabel: 'Queues',
        moveQueue: 'Move to queue',
        timeToMove: 'Time to move',
        timeToClose: 'Time to inactivity',
      },
      users: {
        title: 'Users',
        table: {
          id: 'ID',
          name: 'Name',
          status: 'Status',
          email: 'Email',
          profile: 'Profile',
          actions: 'Actions',
        },
        status: {
          online: 'Online users',
          offline: 'Offline users',
        },
        buttons: {
          add: 'Add user',
        },
        toasts: {
          deleted: 'User deleted successfully.',
        },
        confirmationModal: {
          deleteTitle: 'Delete',
          deleteMessage: 'All user data will be lost. Open tickets from this user will be moved to the queue.',
        },
      },
      helps: {
        title: 'Help Center',
        searchPlaceholder: 'Search by title or description',
        all: 'All',
      },
      schedules: {
        title: 'Schedules',
        confirmationModal: {
          deleteTitle: 'Are you sure you want to delete this Schedule?',
          deleteMessage: 'This action cannot be undone.',
          deleteRecurringMessage: 'Deleting this schedule will remove all schedules linked to it.',
        },
        table: {
          contact: 'Contact',
          body: 'Message',
          sendAt: 'Schedule Date',
          sentAt: 'Send Date',
          status: 'Status',
          actions: 'Actions',
        },
        buttons: {
          add: 'New Schedule',
        },
        viewModal: {
          title: 'Schedule Details',
          attachment: 'Attachment',
          buttons: {
            edit: 'Edit',
            close: 'Close',
          },
          media: {
            view: 'View',
            download: 'Download',
          },
        },
        toasts: {
          deleted: 'Schedule deleted successfully.',
          cannotEditPast: 'You cannot edit schedules in the past.',
          editRecurringInfo: 'This is a recurring schedule. Changes will only affect future sends.',
          editRecurringSingleInfo: 'Changes will apply only to this schedule. Edit the main schedule to update all.',
        },
      },
      tags: {
        title: 'Tags',
        confirmationModal: {
          deleteTitle: 'Are you sure you want to delete this Tag?',
          deleteMessage: 'This action cannot be undone.',
          deleteAllMessage: 'Are you sure you want to delete all Tags?',
          deleteAllTitle: 'Delete All',
        },
        table: {
          name: 'Name',
          color: 'Color',
          tickets: 'Tagged Records',
          kanban: 'Kanban',
          yes: 'Yes',
          no: 'No',
          actions: 'Actions',
        },
        buttons: {
          add: 'New Tag',
          deleteAll: 'Delete All',
        },
        toasts: {
          deletedAll: 'All Tags deleted successfully!',
          deleted: 'Tag deleted successfully.',
        },
      },
      customKanban: {
        title: 'Custom Kanban',
        subtitle: 'Build personalized boards to organize your processes.',
        menuLabel: 'Custom Kanban',
        sections: {
          boards: 'Boards',
          items: 'Board items',
          boardView: 'Board',
        },
        actions: {
          addBoard: 'Add',
          createBoard: 'Create board',
          addColumn: 'Add column',
          addItem: 'Add item',
          addContact: 'Add contact',
          removeItem: 'Remove from kanban',
          goToConversation: 'Go to conversation',
          editBoard: 'Edit board',
          editColumn: 'Edit column',
          deleteBoard: 'Delete board',
          deleteColumn: 'Delete column',
          edit: 'Edit',
          delete: 'Delete',
          shareBoard: 'Share',
          moreOptions: 'More options',
          saveChanges: 'Save changes',
          close: 'Close',
        },
        form: {
          boardName: 'Board name',
          columnName: 'Column name',
          columnColor: 'Column color',
          columnSelect: 'Select a column',
          targetType: 'Item type',
          contactOption: 'Contact',
          ticketOption: 'Ticket',
          contactId: 'Contact ID',
          ticketId: 'Ticket ID',
          searchPlaceholder: 'Search by contact name or number',
          sharedUsers: 'Share with',
          sharedUsersPlaceholder: 'Select users to share this board',
          sharedUsersLoading: 'Loading users...',
          sharedUsersNoOptions: 'No users found',
        },
        labels: {
          columnsCount: 'Columns: {{count}}',
          itemsCount: 'Items: {{count}}',
          totalItems: 'Total items: {{count}}',
          contactInfo: 'Contact #{{id}}',
          ticketInfo: 'Ticket #{{id}}',
          contactWithoutName: 'Contact without name',
          ticketWithoutSubject: 'Ticket without subject',
          contactNumber: 'Number: {{number}}',
          contactWithoutNumber: 'Contact without number',
          sharedWith: 'Shared with',
          sharedWithCount: 'Shared with {{count}} user(s)',
          you: 'You',
        },
        emptyStates: {
          noBoards: 'No boards created yet.',
          selectBoard: 'Select or create a board to get started.',
          noColumns: 'No columns added to this board yet.',
          noItems: 'No items in this column yet.',
          noContacts: 'No contacts found for the current filters.',
          noSharedUsers: 'Only you can see this board for now.',
        },
        toasts: {
          loadError: 'We could not load the kanban boards.',
          boardCreated: 'Board created successfully!',
          boardUpdated: 'Board updated successfully!',
          boardDeleted: 'Board deleted successfully!',
          boardError: 'We could not create the board.',
          boardUpdateError: 'We could not update the board.',
          boardDeleteError: 'We could not delete the board.',
          columnCreated: 'Column added successfully!',
          columnUpdated: 'Column updated successfully!',
          columnDeleted: 'Column deleted successfully!',
          columnMoved: 'Column moved successfully!',
          columnError: 'We could not add the column.',
          columnUpdateError: 'We could not update the column.',
          columnDeleteError: 'We could not delete the column.',
          columnMoveError: 'We could not move the column.',
          itemCreated: 'Item added successfully!',
          itemError: 'We could not add the item.',
          itemMoved: 'Item moved successfully!',
          itemMoveError: 'We could not move the item.',
          itemDeleted: 'Item removed successfully!',
          itemDeleteError: 'We could not remove the item.',
          contactLoadError: 'We could not load contacts.',
          sharedUsersLoadError: 'We couldn’t load the users to share this board.',
          boardPermissionError: 'Only the board owner can perform this action.',
          ticketNavigationError: 'Unable to locate the ticket for this item.',
        },
        validations: {
          boardName: 'Please inform a name for the board.',
          columnName: 'Please inform a name for the column.',
          selectBoard: 'Select a board before continuing.',
          selectColumn: 'Select a column.',
          targetId: 'Inform the contact or ticket identifier.',
          targetNumber: 'Inform a valid numeric identifier.',
        },
        dialogs: {
          addBoardTitle: 'Create new board',
          editBoardTitle: 'Edit board',
          addContactTitle: 'Add contact to column',
          addColumnTitle: 'Create new column',
          editColumnTitle: 'Edit column',
          deleteBoardTitle: 'Delete board',
          deleteColumnTitle: 'Delete column',
        },
        confirmations: {
          deleteBoard: 'Delete the board "{{name}}"? This action cannot be undone.',
          deleteColumn: 'Delete the column "{{name}}" and all its items?',
        },
      },
      crm: {
        title: 'Sales CRM',
        subtitle: 'Track opportunities by contact and move each deal through the funnel.',
        menuLabel: 'Sales CRM',
        conversionsMenuLabel: 'CRM Conversions',
        reportsMenuLabel: 'CRM Reports',
        menu: {
          board: 'Sales funnel',
          conversions: 'Conversions',
          reports: 'Reports',
          settings: 'Settings',
        },
        products: {
          manage: 'Products/services',
          managerTitle: 'Products and services',
          managerDescription: 'Register what you sell to link it to CRM opportunities.',
          add: 'New product/service',
          addTitle: 'Create product/service',
          editTitle: 'Edit product/service',
          edit: 'Edit',
          delete: 'Delete',
          name: 'Name',
          type: 'Type',
          typeProduct: 'Product',
          typeService: 'Service',
          price: 'Price',
          description: 'Description',
          active: 'Active',
          inactive: 'Inactive',
          search: 'Search product/service',
          noResults: 'No products/services found.',
          createFromSearch: 'Create "{{name}}"',
          create: 'Create product/service',
          assign: 'Assign product/service',
          remove: 'Remove product/service',
          noPrice: 'No price',
          label: 'Product/service',
          deleteConfirmation: 'Delete "{{name}}"? Only items without linked opportunities can be deleted; otherwise, deactivate it.',
          toasts: {
            nameRequired: 'Enter the product/service name.',
            invalidPrice: 'Enter a valid price.',
            created: 'Product/service created successfully!',
            updated: 'Product/service updated successfully!',
            deleted: 'Product/service deleted successfully!',
            assigned: 'Product/service assigned to the opportunity!',
            removed: 'Product/service removed from the opportunity!',
          },
        },
        transfer: {
          menuItem: 'Copy or move to another pipeline',
          title: 'Copy or move opportunity',
          description: 'Choose where "{{name}}" should go.',
          copy: 'Copy',
          move: 'Move',
          copyHelper: 'Creates a new opportunity at the destination and keeps the original where it is (tags and product are copied).',
          moveHelper: 'Takes the opportunity to the destination, keeping history, tags, product and follow up.',
          targetPipeline: 'Destination pipeline',
          targetStage: 'Destination stage',
          currentPipeline: '(current)',
          targetRequired: 'Select the destination pipeline and stage.',
          copied: 'Opportunity copied successfully!',
          moved: 'Opportunity moved successfully!',
        },
        reports: {
          title: 'CRM reports',
          subtitle: 'Generate opportunity listings and analyses and export them to Excel or CSV.',
          periodHint: 'Considers opportunities created in the selected period.',
          types: {
            opportunities: {
              title: 'Opportunity listing',
              description: 'All opportunities with contact, pipeline, stage, product, amount and status.',
            },
            products: {
              title: 'Sales by product/service',
              description: 'Count, won and lost amounts and conversion for each product/service.',
            },
            owners: {
              title: 'Performance by owner',
              description: 'Results per owner: opportunities, wins, losses and average ticket.',
            },
          },
          filters: {
            startDate: 'Start date',
            endDate: 'End date',
            pipeline: 'Pipeline',
            allPipelines: 'All pipelines',
            stage: 'Stage',
            allStages: 'All stages',
            status: 'Status',
            allStatuses: 'All statuses',
            product: 'Product/service',
            allProducts: 'All products/services',
            noProduct: 'No product/service',
            owner: 'Owner',
            allOwners: 'All owners',
            noOwner: 'No owner',
            apply: 'Generate report',
          },
          exportXlsx: 'Export Excel',
          exportCsv: 'Export CSV',
          empty: 'No results for the selected filters.',
          rowsCount: '{{count}} record(s)',
          total: 'Total',
          status: {
            open: 'Open',
            won: 'Won',
            lost: 'Lost',
          },
          columns: {
            id: 'ID',
            title: 'Opportunity',
            status: 'Status',
            contact: 'Contact',
            number: 'Phone',
            email: 'Email',
            pipeline: 'Pipeline',
            stage: 'Stage',
            product: 'Product/service',
            productType: 'Type',
            owner: 'Owner',
            amount: 'Amount',
            source: 'Source',
            lossCategory: 'Loss category',
            lostReason: 'Loss reason',
            tags: 'Tags',
            expectedCloseDate: 'Expected close',
            createdAt: 'Created at',
            updatedAt: 'Updated at',
            totalCount: 'Opportunities',
            totalAmount: 'Total amount',
            openCount: 'Open',
            openAmount: 'Open amount',
            wonCount: 'Won',
            wonAmount: 'Won amount',
            lostCount: 'Lost',
            lostAmount: 'Lost amount',
            conversionRate: 'Conversion',
            averageWonTicket: 'Average ticket',
          },
          summary: {
            count: 'Opportunities',
            totalAmount: 'Total amount',
            wonAmount: 'Won amount',
            conversionRate: 'Conversion rate',
          },
        },
        actions: {
          pipelineOptions: 'Pipeline options',
          moreOptions: 'More options',
          clearSearch: 'Clear search',
          managePipeline: 'Manage pipeline',
          manageStages: 'Manage stages',
          searchOpportunities: 'Search by name, title or phone',
          addPipeline: 'Create pipeline',
          editPipeline: 'Edit pipeline',
          duplicatePipeline: 'Duplicate pipeline',
          deletePipeline: 'Delete pipeline',
          deleteStage: 'Delete stage',
          selectPipeline: 'Select',
          addStage: 'New',
          editStage: 'Edit stage',
          moveStageUp: 'Move stage up',
          moveStageDown: 'Move stage down',
          addOpportunity: 'New opportunity',
          addOpportunityToStage: 'New opportunity in this stage',
          openConversation: 'Open conversation',
          previewConversation: 'Preview conversation',
          deleteOpportunity: 'Delete opportunity',
          moveOpportunity: 'Move opportunity',
          moveToStage: 'Move to {{name}}',
          markWon: 'Mark as won',
          markLost: 'Mark as lost',
          showLostStage: 'View lost',
          hideLostStage: 'Hide lost',
          manageLossCategories: 'Manage loss categories',
          addLossCategory: 'New',
          editLossCategory: 'Edit loss category',
          deleteLossCategory: 'Delete loss category',
          activateLossCategory: 'Activate',
          deactivateLossCategory: 'Deactivate',
          cancel: 'Cancel',
          confirm: 'Confirm',
          create: 'Create',
          complete: 'Complete',
          close: 'Close',
          delete: 'Delete',
          save: 'Save',
          viewConversions: 'View conversions',
          openSettings: 'CRM settings',
          backToCrm: 'Back to CRM',
          refreshConversions: 'Refresh report',
          completeFollowUp: 'Complete follow up',
          manageTags: 'Manage tags',
          addTag: 'Add tag',
          createTag: 'Create new',
          editTag: 'Edit tag',
          deleteTag: 'Delete tag',
          edit: 'Edit',
        },
        form: {
          pipeline: 'Pipeline',
          pipelineName: 'Pipeline name',
          stage: 'Stage',
          stageName: 'Stage name',
          stageColor: 'Stage color',
          autoMarkAsWon: 'Mark as won automatically when moved to this stage',
          title: 'Opportunity title',
          contact: 'Contact',
          opportunity: 'Existing opportunity',
          amount: 'Estimated amount',
          expectedCloseDate: 'Expected close date',
          notes: 'Notes',
          followUpFilter: 'Follow-up filter',
          tagFilter: 'Filter by tags',
          tagFilterEmpty: 'No tags found',
          followUpResponsible: 'Follow-up owner',
          followUpDueAt: 'Next follow up',
          followUpNote: 'Follow-up note',
          lostReason: 'Loss reason',
          lossCategory: 'Loss category',
          lossCategoryName: 'Category name',
          lossCategoryActive: 'Active category',
          tagName: 'Tag text',
          tagColor: 'Tag color',
          searchTag: 'Search or create tag',
        },
        labels: {
          opportunityCount: '{{count}} opportunity(ies)',
          stageCount: '{{count}} stage(s)',
          pipelineCopyName: 'Copy of {{name}}',
          duplicatePipelineHelper: 'Only lanes and their settings will be copied, without leads or history.',
          noContact: 'Unknown contact',
          noNumber: 'No number',
          unassigned: 'Unassigned',
          source: 'Source',
          sourceTicket: 'Manual ticket',
          sourceTicketAuto: 'Automatic ticket',
          sourceManual: 'Manual',
          noAmount: 'No amount',
          stageTime: 'In this stage since {{date}}',
          stageTimeNow: 'now',
          expectedCloseDate: 'Close date',
          followUp: 'Follow up',
          followUpResponsible: 'Follow-up owner',
          followUpDueAt: 'Next follow up',
          followUpHistory: 'Follow-up history',
          followUpOutcomeAt: 'Closed at',
          conversationActions: 'Conversation',
          timeline: 'Negotiation timeline',
          actor: 'Actor',
          system: 'System',
          ticketReference: 'Ticket #{{id}}',
          autoWonStage: 'Final stage',
          wonStatus: 'Won',
          lostStatus: 'Lost',
          lostStage: 'Lost',
          lostReason: 'Loss reason',
          lossCategory: 'Loss category',
          lossCategoryActive: 'Active',
          lossCategoryInactive: 'Inactive',
          sortStageTimeLongestFirst: 'Sort by time in stage: longest first',
          sortStageTimeShortestFirst: 'Sort by time in stage: shortest first',
          crmTags: 'Sales tags',
        },
        emptyStates: {
          noPipelines: 'Create a pipeline to start the CRM.',
          noOpportunities: 'No opportunities in this stage.',
          noStages: 'No stages created for this pipeline.',
          noTimeline: 'No events recorded for this opportunity yet.',
          noFollowUp: 'No follow up scheduled.',
          noFollowUpHistory: 'No previous follow up recorded.',
          noFollowUpNote: 'No follow-up note.',
          noLossCategories: 'No loss categories created yet.',
          noTags: 'No tags found.',
        },
        dialogs: {
          addPipeline: 'Create pipeline',
          editPipeline: 'Edit pipeline',
          duplicatePipeline: 'Duplicate pipeline',
          managePipeline: 'Manage pipelines',
          deletePipeline: 'Delete pipeline',
          manageStages: 'Manage stages',
          addStage: 'Create stage',
          editStage: 'Edit stage',
          deleteStage: 'Delete stage',
          addOpportunity: 'Create opportunity',
          opportunityDetails: 'Opportunity details',
          deleteOpportunity: 'Delete opportunity',
          deleteOpportunityConfirmation: 'Do you want to delete this opportunity? This action cannot be undone.',
          markWon: 'Mark opportunity as won',
          markLost: 'Mark opportunity as lost',
          manageLossCategories: 'Manage loss categories',
          addLossCategory: 'Create loss category',
          editLossCategory: 'Edit loss category',
          manageTags: 'Manage tags',
          addTag: 'Create tag',
          editTag: 'Edit tag',
        },
        ticketDialog: {
          title: 'Add contact to CRM',
          description: 'Choose where {{name}} should enter the sales funnel.',
          createMode: 'Create a new opportunity',
          reuseMode: 'Reuse an existing opportunity',
          alreadyInCrmTitle: 'Contact is already in CRM',
          alreadyInCrmDescription: 'This contact already has {{count}} open opportunity(ies). Current position: {{pipeline}} > {{stage}}.',
          notInCrmTitle: 'Contact is not in CRM yet',
          notInCrmDescription: 'You can create a new opportunity to start the commercial follow-up.',
          currentPipeline: 'Current pipeline',
          destinationStage: 'Move to stage',
          reuseHelper: 'Select the existing opportunity and choose only the new stage inside the current pipeline.',
        },
        confirmations: {
          winOpportunity: 'Do you want to mark "{{name}}" as a won opportunity?',
          deletePipeline: 'Do you want to delete the pipeline "{{name}}"? This action removes linked stages and opportunities.',
          deleteStage: 'Do you want to delete the stage "{{name}}"? This action is only allowed when it has no linked opportunities.',
          deleteOpportunity: 'Do you want to delete the opportunity "{{name}}"?',
        },
        toasts: {
          pipelineRequired: 'Select a pipeline before continuing.',
          pipelineNameRequired: 'Provide the pipeline name.',
          stageNameRequired: 'Provide the stage name.',
          opportunityFormRequired: 'Select the contact and stage for the opportunity.',
          pipelineStageRequired: 'Select the pipeline and stage.',
          opportunityRequired: 'Select the opportunity to reuse.',
          pipelineCreated: 'Pipeline created successfully!',
          pipelineDuplicated: 'Pipeline duplicated successfully!',
          pipelineUpdated: 'Pipeline updated successfully!',
          pipelineDeleted: 'Pipeline deleted successfully!',
          stageCreated: 'Stage created successfully!',
          stageUpdated: 'Stage updated successfully!',
          stageDeleted: 'Stage deleted successfully!',
          stageOrderUpdated: 'Stage order updated successfully!',
          lossCategoryRequired: 'Select a loss category.',
          lossCategoryNameRequired: 'Provide the loss category name.',
          lossCategoryCreated: 'Loss category created successfully!',
          lossCategoryUpdated: 'Loss category updated successfully!',
          lossCategoryDeleted: 'Loss category deleted successfully!',
          automationSettingsSaved: 'Automation settings saved successfully!',
          opportunityCreated: 'Opportunity created successfully!',
          opportunityUpdated: 'Opportunity updated successfully!',
          opportunityMoved: 'Opportunity moved successfully!',
          opportunityWon: 'Opportunity marked as won!',
          opportunityLost: 'Opportunity marked as lost!',
          opportunityDeleted: 'Opportunity deleted successfully!',
          ticketAdded: 'Contact added to CRM successfully!',
          ticketConversationNotFound: 'Unable to locate this ticket conversation from CRM.',
          automationTriggerRequired: 'Provide at least one queue or keyword to enable automation.',
          automationDaysInvalid: 'Enter a number of days between 1 and 365.',
          automationLossCategoryRequired: 'Select the inactivity loss reason.',
          followUpRequired: 'Provide both owner and date/time to save the follow up.',
          followUpRequiredFields: 'Provide both owner and date/time to save the follow up.',
          followUpSaved: 'Follow-up saved successfully!',
          followUpCompleted: 'Follow up completed successfully!',
          tagNameRequired: 'Provide the tag text.',
          tagCreated: 'Tag created successfully!',
          tagUpdated: 'Tag updated successfully!',
          tagDeleted: 'Tag deleted successfully!',
        },
        followUp: {
          filters: {
            all: 'All',
            pending: 'Pending',
            today: 'Today',
            overdue: 'Overdue',
            assigned_to_me: 'Assigned to me',
          },
          status: {
            pending: 'Pending',
            today: 'Today',
            overdue: 'Overdue',
          },
        },
        settings: {
          title: 'CRM Settings',
          subtitle: 'Centralize loss reasons and configure automatic lead entry for each pipeline.',
          automationTitle: 'Pipeline automation',
          automationDescription: 'Automatically create a new lead when the ticket matches the configured keywords or enters one of the selected queues.',
          automationEnabled: 'Automatic',
          triggerLabel: 'Trigger',
          triggers: {
            accept_ticket: 'On ticket acceptance',
            message_received: 'On message received or queue entry',
          },
          triggerHelpers: {
            accept_ticket: 'The lead is created when an agent accepts the ticket.',
            message_received: 'The lead is created as soon as the customer sends a keyword or the ticket enters one of the queues, before anyone accepts it.',
          },
          firstContactRuleLabel: 'Contact rule',
          firstContactOnly: 'Only on the contact first ticket',
          allTickets: 'All tickets',
          contactRuleHelper: 'In every case, no new lead is created if the contact already has an open opportunity in this pipeline.',
          targetStage: 'Entry stage',
          defaultProduct: 'Default product/service',
          defaultProductHelper: 'Linked to the automatically created lead. The product price becomes the opportunity value.',
          noDefaultProduct: 'None',
          funnelAutomationsTitle: 'Funnel automations',
          funnelAutomationsDescription: 'Automatic actions on this pipeline opportunities. They work even when automatic creation is off.',
          acceptTicketStageId: 'On ticket acceptance, move to',
          closeTicketStageId: 'On ticket close, move to',
          moveStageHelper: 'Moves the contact open opportunity only forward in the funnel.',
          doNotMove: 'Do not move',
          staleFollowUpDays: 'Create follow-up after days stalled in stage',
          staleFollowUpDaysHelper: 'Creates a follow-up for the owner when the opportunity stays this many days in the same stage. Leave empty to disable.',
          inactivityLossDays: 'Mark as lost after days without reply',
          inactivityLossDaysHelper: 'Marks the opportunity as lost when the customer sends no message in this period. Leave empty to disable.',
          inactivityLossCategory: 'Inactivity loss reason',
          logCustomerMessages: 'Log customer messages on the timeline',
          logCustomerMessagesHelper: 'When the customer sends a message, logs it on the open opportunity timeline (at most once a day) and it no longer counts as stalled.',
          keywords: 'Keywords',
          keywordsHelper: 'Type a keyword and press Enter to create a chip. Click the chip x to remove it.',
          keywordsPlaceholder: 'Type and press Enter',
          queues: 'Queues',
          queuesHelper: 'Select one or more queues. If the ticket is in any of them, the lead will be created automatically.',
          queuesPlaceholder: 'Select queues',
          saveAutomation: 'Save automation',
          lossCategoryDescription: 'Manage the reasons used when an opportunity is marked as lost.',
        },
        conversions: {
          title: 'CRM sales flow dashboard',
          subtitle: 'Track how many opportunities were created, won, and lost to identify funnel gaps and commercial trends.',
          allPipelines: 'All pipelines',
          startDate: 'Start date',
          endDate: 'End date',
          granularity: 'Granularity',
          daily: 'Daily',
          weekly: 'Weekly',
          monthly: 'Monthly',
          chartTitle: 'Wins and losses volume over time',
          pipelineBreakdown: 'Performance by pipeline',
          previousPeriodComparison: 'Comparison with previous period',
          lossCategoryBreakdown: 'Loss reasons',
          stageFunnel: 'Stage funnel',
          share: 'Share',
          metric: 'Metric',
          currentPeriod: 'Current period',
          previousPeriod: 'Previous period',
          variation: 'Variation',
          emptyChart: 'No data found for the selected period.',
          emptyBreakdown: 'No results found for the current filters.',
          funnel: {
            enteredCount: 'Entered',
            advancedCount: 'Advanced',
            advancementRate: 'Advancement rate',
            winRate: 'Win rate',
            lossRate: 'Loss rate',
          },
          summary: {
            convertedCount: 'Won',
            convertedAmount: 'Won amount',
            createdCount: 'Created',
            conversionRate: 'Conversion rate',
            lostCount: 'Lost',
            lostAmount: 'Lost amount',
            lossRate: 'Loss rate',
          },
          sources: {
            auto_stage: 'Automatic stage',
            manual_button: 'Mark as won button',
            lost: 'Marked as lost',
            other: 'Unmapped source ({{key}})',
          },
        },
      },
      settings: {
        success: 'Settings saved successfully.',
        title: 'Settings',
        settings: {
          userCreation: {
            name: 'User creation',
            options: {
              enabled: 'Enabled',
              disabled: 'Disabled',
            },
          },
          timezone: {
            name: 'Timezone',
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: 'Assigned to:',
          notMessage: 'There are no messages in this ticket.',
          buttons: {
            return: 'Return',
            resolve: 'Resolve',
            reopen: 'Reopen',
            accept: 'Accept',
            closeWithoutBot: 'Close without notification',
          },
        },
        privateMessage: {
          label: 'Private note · {{name}}',
          unknownAuthor: 'Agent',
          deleted: 'This note was deleted.',
          options: 'Note options',
        },
      },
      showTicketLogModal: {
        title: {
          header: 'Ticket History',
        },
        options: {
          create: 'Created',
          chatBot: 'Bot',
          queue: 'Queue',
          open: 'Opened',
          access: 'Access',
          transfered: 'Transferred',
          receivedTransfer: 'Received transfer',
          pending: 'Pending',
          closed: 'Closed',
          reopen: 'Reopened',
          redirect: 'Redirected',
        },
      },
      frontEndErrors: {
        getUsers: 'Error loading users.',
      },
      allTicket: {
        form: {
          viewTags: 'View tags',
        },
      },
      messagesInput: {
        placeholderOpen: 'Type a message',
        placeholderClosed: 'Reopen or accept this ticket to send a message.',
        signMessage: 'Sign',
        pendingTicketInfo: 'This ticket is waiting. Accept the ticket before replying to messages.',
        privateMode: {
          label: 'Send type',
          message: 'Message',
          note: 'Private note',
          placeholder: 'Write a note for the team…',
          save: 'Save note',
          hint: 'Only the team sees this note. The customer receives nothing on WhatsApp.',
        },
      },
      contactDrawer: {
        header: 'Contact details',
        buttons: {
          edit: 'Edit contact',
        },
        block: {
          title: 'Block',
          blockedLabel: 'This contact is blocked on WhatsApp and cannot send messages to the connection.',
          block: 'Block contact',
          unblock: 'Unblock contact',
          confirmBlockTitle: 'Block this contact?',
          confirmBlockMessage: "The number will be blocked on this ticket's WhatsApp connection and will no longer be able to send messages to it. You can unblock it later from this panel.",
          confirmUnblockTitle: 'Unblock this contact?',
          confirmUnblockMessage: "The number will be able to send messages to this ticket's connection again.",
          blocked: 'Contact blocked.',
          unblocked: 'Contact unblocked.',
        },
        crm: {
          title: 'CRM',
          inCrm: 'This contact already has an open CRM opportunity.',
          notInCrm: 'This contact does not have an open CRM opportunity yet.',
          moveAction: 'Move in CRM',
          addAction: 'Add to CRM',
          transferAction: 'Copy / move',
          openCount: '{{count}} open CRM opportunities',
        },
        extraInfo: 'Additional information',
        group: {
          title: 'Group members',
          refresh: 'Refresh',
          add: 'Add members',
          remove: 'Remove',
          empty: 'No members found for this group.',
          missingIdentifiers: 'Unable to manage participants for this contact.',
          count: 'Members: {{count}}',
          unknown: 'Unknown',
          roles: {
            admin: 'Admin',
            superAdmin: 'Super admin',
          },
          modal: {
            title: 'Add group members',
            description: 'Search and select contacts to add to this group.',
            searchLabel: 'Contacts',
            searchPlaceholder: 'Type to search contacts',
            loading: 'Loading contacts...',
            noOptions: 'No contacts found',
            cancel: 'Cancel',
            confirm: 'Add members',
          },
          toasts: {
            missingInformation: 'Missing information to manage this group.',
            noContacts: 'Select at least one contact to continue.',
            addSuccess: 'Participants added successfully!',
            removeSuccess: 'Participant removed successfully!',
          },
          confirmation: {
            title: 'Remove participant',
            message: 'Are you sure you want to remove {{name}} from this group?',
          },
        },
      },
      fileModal: {
        title: {
          add: 'Add file list',
          edit: 'Edit file list',
        },
        buttons: {
          okAdd: 'Save',
          okEdit: 'Edit',
          cancel: 'Cancel',
          fileOptions: 'Add file',
        },
        form: {
          name: 'File list name',
          message: 'List details',
          fileOptions: 'File list',
          extraName: 'Message to send with file',
          extraValue: 'Option value',
        },
        success: 'File list saved successfully!',
      },
      ticketOptionsMenu: {
        addToCrm: 'Add to CRM',
        schedule: 'Schedule',
        delete: 'Delete',
        transfer: 'Transfer',
        closeWithoutBot: 'Close without bot message',
        closeWithoutBotModal: {
          title: 'Close without bot message',
          message: 'The ticket will be closed without sending the closing message to the client.',
        },
        registerAppointment: 'Contact Notes',
        appointmentsModal: {
          title: 'Contact Notes',
          textarea: 'Note',
          placeholder: 'Enter the information you want to register here',
        },
        confirmationModal: {
          title: 'Delete ticket',
          titleFrom: 'from contact ',
          message: 'Warning! All messages related to the ticket will be lost.',
        },
        buttons: {
          delete: 'Delete',
          cancel: 'Cancel',
        },
      },
      confirmationModal: {
        buttons: {
          confirm: 'Ok',
          cancel: 'Cancel',
        },
      },
      messageOptionsMenu: {
        delete: 'Delete',
        reactionSuccess: 'Reaction added',
        reply: 'Reply',
        edit: 'Edit Message',
        forward: 'Forward',
        toForward: 'Forward',
        react: 'React',
        confirmationModal: {
          title: 'Delete message?',
          message: 'This action cannot be undone.',
        },
        privateMessage: {
          edit: 'Edit note',
          delete: 'Delete note',
          confirmationModal: {
            title: 'Delete private note?',
            message: 'The note will no longer be visible to the team. This action cannot be undone.',
          },
        },
      },
      backendErrors: {
        ERR_APPOINTMENT_NOTIFICATIONS_DISABLED: 'Choose a WhatsApp connection in the notification settings first.',
        ERR_APPOINTMENT_NOTIFICATION_FAILED: 'WhatsApp could not send the notification. Check the connection.',
        ERR_APPOINTMENT_NO_ACTIVE_CONVERSATION: 'There is no open conversation with the customer.',
        ERR_APPOINTMENT_TEMPLATE_INVALID: 'One of the messages is invalid or too long.',
        ERR_APPOINTMENT_AI_NOT_CONFIGURED: 'The AI is not configured in this environment.',
        ERR_APPOINTMENT_AI_FAILED: 'The AI could not be reached.',
        ERR_GOOGLE_CALENDAR_NOT_CONFIGURED: 'The Google Calendar integration is not configured.',
        ERR_GOOGLE_CALENDAR_NOT_CONNECTED: 'Google Calendar is not connected.',
        ERR_GOOGLE_CALENDAR_ACCESS_REVOKED: 'Google access was revoked or expired. Reconnect to continue syncing.',
        ERR_GOOGLE_CALENDAR_NOT_FOUND: 'Calendar not found or without edit permission.',
        ERR_GOOGLE_CALENDAR_INVALID_STATE: 'The connection link expired. Try again.',
        ERR_GOOGLE_CALENDAR_NO_REFRESH_TOKEN: 'Google did not grant offline access. Try again.',
        ERR_GOOGLE_CALENDAR_SCOPES_MISSING: 'Grant all the requested permissions to connect.',
        ERR_GOOGLE_CALENDAR_SYNC_FAILED: 'Google Calendar could not be reached. Try again.',
        ERR_GOOGLE_EVENT_REMOVED: 'The event was deleted in Google Calendar. Try again to create it again.',
        ERR_APPOINTMENT_CALENDAR_BLOCKED: 'This time is busy in Google Calendar. Choose another time.',
        ERR_APPOINTMENT_NOT_FOUND: 'Appointment not found.',
        ERR_APPOINTMENT_TYPE_NOT_FOUND: 'Appointment type not found or inactive.',
        ERR_APPOINTMENT_FIELD_NOT_FOUND: 'Field not found.',
        ERR_APPOINTMENT_TIME_CONFLICT: 'This time is already taken. Choose another time.',
        ERR_APPOINTMENT_CLOSED: 'This appointment is already closed and cannot be changed.',
        ERR_APPOINTMENT_NOT_CANCELLED: 'Only a cancelled appointment can be reactivated.',
        ERR_APPOINTMENT_REACTIVATE_PAST: 'This appointment time has already passed. Create a new appointment.',
        ERR_APPOINTMENT_TYPE_IN_USE: 'This type is used in appointments and cannot be deleted. Deactivate it instead.',
        ERR_APPOINTMENT_PROFESSIONAL_NOT_LINKED: 'Your user is not linked to a professional.',
        ERR_APPOINTMENT_PROFESSIONAL_USER_NOT_FOUND: 'Access user not found in this company.',
        ERR_APPOINTMENT_PROFESSIONAL_USER_IN_USE: 'This user is already linked to another professional.',
        ERR_APPOINTMENT_PROFESSIONAL_INVALID_SCHEDULE: 'Check the professional\'s working hours.',
        ERR_APPOINTMENT_PROFESSIONAL_UNCHANGED: 'The appointment is already assigned to this professional.',
        ERR_APPOINTMENT_PROFESSIONAL_NOT_FOUND: 'Professional not found or inactive.',
        ERR_APPOINTMENT_PROFESSIONAL_REQUIRED: 'Choose the professional for the appointment.',
        ERR_APPOINTMENT_PROFESSIONAL_IN_USE: 'This professional has appointments and cannot be deleted. Deactivate them instead.',
        ERR_APPOINTMENT_IN_THE_PAST: 'Choose a date and time in the future.',
        ERR_APPOINTMENT_INVALID_DATE: 'Invalid date.',
        ERR_APPOINTMENT_INVALID_RANGE: 'Invalid date range.',
        ERR_APPOINTMENT_RANGE_TOO_LARGE: 'The date range is too large.',
        ERR_APPOINTMENT_FIELD_REQUIRED: 'Fill in all the required fields.',
        ERR_APPOINTMENT_FIELD_INVALID: 'One of the fields has an invalid value.',
        ERR_APPOINTMENT_FIELD_OPTIONS_REQUIRED: 'Add at least one option to the list.',
        ERR_PRIVATE_MESSAGE_BODY_REQUIRED: 'Write the note text before saving.',
        ERR_PRIVATE_MESSAGE_ACTION_NOT_ALLOWED: 'This action is not available for private notes.',
        ERR_NO_MESSAGE_FOUND: 'Message not found.',
        ERR_CRM_STAGE_HAS_OPPORTUNITIES: 'This stage has linked opportunities and cannot be deleted.',
        ERR_CRM_STAGE_ORDER_REQUIRED: 'Provide the new stage order.',
        ERR_CRM_STAGE_ORDER_INVALID: 'The provided stage order is invalid.',
        ERR_CRM_AUTO_WON_STAGE_ALREADY_EXISTS: 'A final stage is already configured for this pipeline.',
        ERR_NO_CRM_TAG_FOUND: 'Sales tag not found.',
        ERR_CRM_TAG_NAME_REQUIRED: 'Provide the tag text.',
        ERR_CRM_TAG_ALREADY_EXISTS: 'A sales tag with this text already exists.',
        ERR_CRM_TAG_IN_USE: 'This tag is linked to opportunities and cannot be deleted.',
        ERR_CRM_TAG_REQUIRED: 'Select a tag.',
        ERR_NO_CRM_PRODUCT_FOUND: 'Product/service not found.',
        ERR_CRM_PRODUCT_NAME_REQUIRED: 'Enter the product/service name.',
        ERR_CRM_PRODUCT_INVALID_PRICE: 'Enter a valid price.',
        ERR_CRM_PRODUCT_ALREADY_EXISTS: 'A product/service with this name already exists.',
        ERR_CRM_PRODUCT_IN_USE: 'This product/service is linked to opportunities. Deactivate it instead of deleting.',
        ERR_CRM_PRODUCT_INACTIVE: 'This product/service is inactive.',
        ERR_CRM_TRANSFER_MODE_INVALID: 'Choose to copy or move the opportunity.',
        ERR_CRM_TRANSFER_TARGET_REQUIRED: 'Select the destination pipeline and stage.',
        ERR_CRM_TRANSFER_SAME_STAGE: 'The opportunity is already in this stage.',
        ERR_NO_OTHER_WHATSAPP: 'There must be at least one default WhatsApp.',
        ERR_NO_DEF_WAPP_FOUND: 'No default WhatsApp found. Check the connections page.',
        ERR_WAPP_NOT_INITIALIZED: 'This WhatsApp session was not initialized. Check the connections page.',
        ERR_WAPP_CHECK_CONTACT: 'Could not verify WhatsApp contact. Check the connections page',
        ERR_WAPP_INVALID_CONTACT: 'This is not a valid Whatsapp number.',
        ERR_WAPP_DOWNLOAD_MEDIA: 'Could not download media from WhatsApp. Check the connections page.',
        ERR_WAPP_PAIRING_CODE_NOT_GENERATED: 'Could not generate the connection code. Wait a few seconds and try again.',
        ERR_INVALID_CREDENTIALS: 'Authentication error. Please try again.',
        ERR_SENDING_WAPP_MSG: 'Error sending WhatsApp message. Check the connections page.',
        ERR_DELETE_WAPP_MSG: 'Could not delete WhatsApp message.',
        ERR_OTHER_OPEN_TICKET: 'There is already an open ticket for this contact.',
        ERR_OTHER_OPEN_TICKET_DETAILS: 'Queue {{queue}} • User {{user}}.',
        ERR_SESSION_EXPIRED: 'Session expired. Please login.',
        ERR_USER_CREATION_DISABLED: 'User creation has been disabled by the administrator.',
        ERR_NO_PERMISSION: "You don't have permission to access this resource.",
        NO_PARTICIPANT_NUMBERS: 'No participant identifiers were provided.',
        NO_VALID_PARTICIPANTS: 'None of the provided values could be interpreted as participants.',
        ERR_ADD_GROUP_PARTICIPANT: 'An error occurred while adding participants to the group.',
        ERR_REMOVE_GROUP_PARTICIPANT: 'An error occurred while removing participants from the group.',
        ERR_DUPLICATED_CONTACT: 'A contact with this number already exists.',
        ERR_NO_SETTING_FOUND: 'No setting found with this ID.',
        ERR_NO_CONTACT_FOUND: 'No contact found with this ID.',
        ERR_CANNOT_BLOCK_GROUP_CONTACT: 'Groups cannot be blocked.',
        ERR_NO_TICKET_FOUND: 'No ticket found with this ID.',
        ERR_NO_USER_FOUND: 'No user found with this ID.',
        ERR_NO_WAPP_FOUND: 'No WhatsApp found with this ID.',
        ERR_USER_WHATSAPP_NOT_ALLOWED: 'You do not have access to this connection.',
        ERR_USER_DEFAULT_WHATSAPP_NOT_ALLOWED: 'The default connection must be one of the allowed connections.',
        ERR_CREATING_MESSAGE: 'Error creating message in database.',
        ERR_CREATING_TICKET: 'Error creating ticket in database.',
        ERR_FETCH_WAPP_MSG: "Error fetching message in WhtasApp, maybe it's too old.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS: 'This color is already in use, choose another one.',
        ERR_WAPP_GREETING_REQUIRED: 'Greeting message is required when there is more than one queue.',
        ERR_WAPP_AGENT_TEST_REQUIRES_QUEUE: 'When the connection agent is in test mode, the connection must have at least one queue for the normal chatbot flow.',
        ERR_CHECK_NUMBER: 'Invalid number. Check the number and try again.',
        ERR_COMPANY_DOCUMENT_ALREADY_EXISTS: 'A company with these details already exists. Please verify the provided information.',
        ERR_COMPANY_EMAIL_ALREADY_EXISTS: 'This email is already in use. Sign in or recover your password.',
        ERR_WEAK_PASSWORD: 'Use 8 or more characters, with uppercase and lowercase letters and a number.',
        ERR_INVALID_RESET_TOKEN: 'Invalid or expired code. Check the code or request a new one.',
        ERR_TOO_MANY_REQUESTS: 'Too many attempts. Wait a few minutes and try again.',
        ERR_SIGNUP_DISABLED: 'New sign-ups are closed right now.',
        ERR_TERMS_NOT_ACCEPTED: 'Accept the terms to create your account.',
        ERR_PLAN_NOT_AVAILABLE: 'This plan is not available for sign-up. Choose another one.',
        ERR_QUICKMESSAGE_NAME_ALREADY_EXISTS: 'A quick response with this name already exists.',
      },
      companyExpiredModal: {
        title: 'Company Expired',
        message: 'Please settle your payments to continue using the system.',
      },
    },
  },
}

export { messages }
